import styled from 'styled-components';

import * as Common from '../../../Styles';
import * as MUIIcon from '@mui/icons-material';

const Theme = Common.Theme;

export const CloseIcon = styled(MUIIcon.Close)`
	font-size: 16px !important;
	color: ${Theme.red};
`;

export const ErrorSummaryIcon = styled(MUIIcon.Cancel)`
	font-size: 3rem !important;
	color: ${Theme.error};
`;
